// Khaali string - package.json ka proxy handle karta hai
// Deploy karte waqt yahan asli backend URL aayega
export const API_BASE_URL = '';

export const USER_API = `${API_BASE_URL}/api/users`;
export const POOJARI_API = `${API_BASE_URL}/api/poojaris`;
export const BOOKING_API = `${API_BASE_URL}/api/bookings`;
export const REVIEW_API = `${API_BASE_URL}/api/reviews`;
export const PAYMENT_API = `${API_BASE_URL}/api/payments`;
export const ADMIN_API = `${API_BASE_URL}/api/admin`;